export default "__VITE_ASSET__cf5bebc4__"